import { proxy } from 'valtio';
export const useAmplitudeStore = proxy({
    data: [],
});
